import client from '@/api/client'

/**
 * Get list of companies for account id
 *
 * @param {String} accountId
 * @returns {Promise}
 */
export function accountList(accountId) {
  return client
    .get(`/orgstructure/v1/companies-posts/${accountId}`)
    .then(response => response.data)
}




// WEBPACK FOOTER //
// ./src/apps/orgstructure/api/index.js